const styleMapping = {
    'stripe-75c3c10d-3255-4289-aa3a-08bb60fef3ff.svg': {
        height: '22px',
        top: '3px'
    }
};
export default styleMapping;
